"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandColors = void 0;
// From "Decodable - Brand Guidline.pdf" in GDrive
exports.brandColors = {
    primary: {
        main: "#0E0F18",
        blue: "#2F74F9", // Ultramarine Blue
    },
    blue: {
        light: "#45CDFF",
        main: "#2F74F9",
        contrastText: "white",
    },
    red: {
        main: "#F44C4C",
    },
    plum: {
        main: "#FF70F1",
    },
    green: {
        main: "#44E1BC",
        contrastText: "black",
    },
    yellow: {
        main: "#FFE182",
    },
};
